;(function () {
  window.html = function html(strings) {
    var out = strings[0]
    var len = arguments.length

    for (var i = 1; i < len; i++) {
      var val = arguments[i]

      if (val == null || typeof val == 'boolean') {
        val = ''
      } else if (Array.isArray(val)) {
        val = val.join('\n')
      }

      out += val + strings[i]
    }

    return out
  }

  window.active = function active(opt = {}) {
    document.querySelectorAll(opt.selector || 'a').forEach(function (el) {
      if (el.pathname === location.pathname) {
        el.classList.add(opt.active || 'active')
      }
    })
  }

  window.back = function back() {
    var path = sessionStorage.getItem('track') || '/'
    window.location = path
  }

  window.blur = function blur(el) {
    if (el.closest('.toggle,.open')) return

    document.querySelectorAll('.open').forEach(function (el) {
      el.classList.remove('open')
    })
  }

  window.client = async function client(path, data = {}, opt = {}) {
    var response = await fetch(path, {
      method: opt.method || 'POST',
      headers: Object.assign(
        { 'Content-Type': 'application/json; charset=utf-8' },
        opt.headers || {}
      ),
      credentials: 'include',
      body: JSON.stringify(data)
    })
    return response.json()
  }

  window.cookie = function cookie(key, val, opt) {
    var options = opt || {}

    if (val === undefined) {
      var pairs = document.cookie.split('; ')
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=')
        if (pair[0] === key) {
          try {
            return decodeURIComponent(pair[1] || '')
          } catch (e) {
            return pair[1]
          }
        }
      }
      return null
    }

    if (val === null) {
      val = ''
      options.days = -1
    }

    var days = options.days !== undefined ? options.days : 30
    var path = options.path || '/'
    var expires = ''

    if (days !== 0) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = ';expires=' + date.toUTCString()
    }

    var str = key + '=' + encodeURIComponent(val) + ';path=' + path + expires

    if (options.domain) str += ';domain=' + options.domain
    if (options.sameSite) str += ';SameSite=' + options.sameSite
    if (options.secure) str += ';Secure'

    document.cookie = str
  }

  window.copy = function copy(input) {
    if (typeof input == 'string') {
      input = document.querySelector(input)
    }
    if (!input) return

    input.select()
    input.setSelectionRange(0, 99999)

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(input.value)
    } else if (typeof document.execCommand == 'function') {
      document.execCommand('copy')
    }
  }

  window.download = function download(input, filename) {
    function trigger(blob, name) {
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = name || 'download'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      setTimeout(function () {
        URL.revokeObjectURL(url)
        a.remove()
      }, 150)
      return a
    }

    if (input instanceof Blob) {
      return trigger(input, filename)
    }

    var url = input.href || input
    var name =
      filename ||
      url.substring(url.lastIndexOf('/') + 1).split('?')[0] ||
      'download'

    var xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.onload = function () {
      trigger(xhr.response, name)
    }
    xhr.open('GET', url)
    xhr.send()
  }

  window.file = async function file(input) {
    var files = input.files
    if (!files || !files.length) return

    var field = input.closest('.field')

    var action = field.getAttribute('data-action')
    var output = field.querySelector('output')
    var progress = field.querySelector('progress')
    var hidden = field.querySelector('input[type=hidden]')
    var source = field.querySelector('picture source')
    var spinner = field.querySelector('.spinner')

    field.querySelectorAll('em[class$="-errors"]').forEach(function (em) {
      em.textContent = ''
    })

    if (spinner) spinner.style.display = 'inline-block'

    var urls = []

    for (var i = 0; i < files.length; i++) {
      var file = files[i]

      if (output) output.value = i + 1 + ' / ' + files.length
      if (progress) progress.value = 0

      var result = await window.client(action, {
        params: {
          name: file.name,
          type: file.type,
          size: file.size
        }
      })

      if (result && result.ok === false) {
        if (result.message) {
          window.flash(result.message, { class: 'error' })
        }
        if (spinner) spinner.style.display = 'none'
        return
      }

      var link = result.data
      var res = await window.upload(link, file, {
        progress: progress
          ? function (e) {
              progress.value = e.percent || 0
            }
          : null
      })

      urls.push(res.url)
    }

    if (source) source.srcset = urls[0]
    if (hidden) hidden.value = urls.join(',')
    if (progress) progress.value = 100
    if (spinner) spinner.style.display = 'none'
  }

  window.flash = function flash(message, opt = {}) {
    var el = opt.el
      ? document.querySelector(opt.el)
      : document.querySelector('.prompt-flash .message') ||
        document.querySelector('.modal-flash .message') ||
        document.querySelector('.flash .message')
    var time = opt.time || 5000
    var name = opt.name || 'flash'

    if (!el) return null

    if (typeof window.__flash != 'undefined') {
      clearTimeout(window.__flash)
    }

    message = (message || cookie(name) || '').trim()
    cookie(name, null)

    if (opt.scroll != false) {
      scroll(0, 0)
    }
    if (opt.class) {
      el.classList.add(opt.class)
    }

    el.textContent = message
    el.style.opacity = 1

    if (time) {
      window.__flash = setTimeout(function () {
        el.style.opacity = 0
        if (opt.class) {
          el.classList.remove(opt.class)
        }
      }, time)
    }
    return el
  }

  window.load = async function load(path, into) {
    var response = await fetch(path)
    var content = await response.text()
    if (typeof into == 'string') {
      into = document.querySelector(into)
    }
    if (into) {
      into.innerHTML = content
      into.querySelectorAll('script').forEach(function (script) {
        if (!script.loaded) {
          script.loaded = true
          eval(script.textContent)
        }
      })
    }
    return content
  }

  window.params = function params(id) {
    if (id == null) return ''
    if (typeof id != 'string') {
      id = parseInt(id || 0) + 1
      return location.pathname.split('/')[id]
    }
    id = id.replace(/[[\]]/g, '\\$&')
    var matcher = new RegExp('[?&]' + id + '=([^&#]*)')
    var result = matcher.exec(location.search)
    if (result) {
      return decodeURIComponent(result[1].replace(/\+/g, ' '))
    }
    return ''
  }

  window.serialize = function serialize(form) {
    if (typeof form == 'string') form = document.querySelector(form)
    if (!form) return {}

    var data = {}

    function get(el) {
      var val = el.value || el.getAttribute('data-default')
      if (val == null) return

      var type = el.getAttribute('data-type') || el.type
      if (type == 'array') {
        if (val == '[]') return []
        return val.split(',').map(function (x) {
          return x.trim()
        })
      }
      if (type == 'number') return +val
      if (type == 'date') return new Date(Date.parse(val) || Date.now())
      if (type == 'null') return null
      if (type == 'bool') {
        if (val == 'false' || val == '0' || val == 'off') return false
        return !!val
      }
      return val
    }

    function set(obj, path, value, isCheckbox) {
      var parts = path.split('.')
      var current = obj
      for (var i = 0; i < parts.length; i++) {
        var key = parts[i]
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
          break

        if (i === parts.length - 1) {
          if (isCheckbox) {
            if (!current[key]) current[key] = []
            if (value !== undefined) current[key].push(value)
          } else {
            current[key] = value
          }
        } else {
          if (!current[key] || typeof current[key] !== 'object') {
            current[key] = {}
          }
          current = current[key]
        }
      }
    }

    for (var i = 0; i < form.elements.length; i++) {
      var field = form.elements[i]
      if (!field.name || field.disabled) continue
      if (/^(file|reset|submit|button)$/.test(field.type)) continue

      if (field.type == 'select-multiple') {
        var values = []
        for (var j = 0; j < field.options.length; j++) {
          if (field.options[j].selected) {
            values.push(get(field.options[j]))
          }
        }
        set(data, field.name, values)
      } else if (field.type == 'checkbox') {
        if (field.checked) {
          set(data, field.name, get(field), true)
        }
      } else if (field.type != 'radio' || field.checked) {
        var val = get(field)
        if (val !== undefined) set(data, field.name, val)
      }
    }

    return data
  }

  window.store = function store(key, val) {
    function get() {
      var item = sessionStorage.getItem(key)
      if (item != null) {
        try {
          return JSON.parse(item)
        } catch (error) {
          sessionStorage.removeItem(key)
        }
      }
    }

    if (!key) {
      return sessionStorage.clear()
    }

    if (val === null) {
      var item = get()
      sessionStorage.removeItem(key)
      return item
    }

    if (val != null) {
      sessionStorage.setItem(key, JSON.stringify(val))
      return val
    }

    return get()
  }

  window.submit = async function submit(form, opt = {}) {
    if (!form || form.nodeName !== 'FORM') return

    opt.error ??= form.getAttribute('data-error')

    form.querySelectorAll('em[class$="-errors"]').forEach(function (em) {
      em.textContent = ''
    })

    form.querySelectorAll('input, textarea, select').forEach(function (el) {
      function event() {
        var parent = el.closest('.field')
        if (parent) {
          var em = parent.querySelector('em[class$="-errors"]')
          if (em) em.textContent = ''
        }
      }
      el.addEventListener('input', event)
      el.addEventListener('change', event)
    })

    var btn = form.querySelector('[type="submit"]')
    if (btn) btn.disabled = true

    var values = window.serialize(form)
    var action = form.getAttribute('action') || ''

    var result
    try {
      result = await window.client(action, {
        params: values
      })
    } catch (err) {
      window.flash(err.message, { class: 'error' })
      if (btn) btn.disabled = false
      return
    }

    if (result && result.ok === false) {
      var message = result.message ?? opt.error
      if (message) {
        window.flash(message, { class: 'error' })
      }
      if (result.fields) {
        for (var field in result.fields) {
          var em = form.querySelector('em.' + field + '-errors')
          if (em) em.textContent = result.fields[field].join(', ')
        }
      }
      if (btn) btn.disabled = false
      return
    }

    opt.success ??= form.getAttribute('data-success')
    opt.redirect ??= form.getAttribute('data-redirect')

    if (opt.success) {
      window.cookie('flash', opt.success)
    }
    if (opt.redirect) {
      window.location = opt.redirect
      return
    }

    window.location.reload()
  }

  window.toggle = function toggle(name, el) {
    if (!el) return
    document.querySelectorAll('.' + name).forEach(function (x) {
      if (x !== el) x.classList.remove(name)
    })
    el.classList.toggle(name)
  }

  window.track = function track() {
    sessionStorage.setItem('track', location.href || '/')
  }

  window.upload = function upload(link, file, opt = {}) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest()
      var data = new FormData()

      xhr.onload = function () {
        var url = xhr.getResponseHeader('Location')
        if (url) return resolve({ url: url })
        reject({ error: { message: opt.error || 'upload failed' } })
      }

      xhr.onerror = function () {
        reject({ error: { message: opt.error || 'upload error' } })
      }

      xhr.onabort = function () {
        reject({ error: { message: opt.error || 'upload abort' } })
      }

      if (opt.progress) {
        xhr.upload.onprogress = function (e) {
          if (e.total > 0) e.percent = Math.round((e.loaded / e.total) * 100)
          opt.progress(e)
        }
      }

      if (link.method === 'PUT') {
        xhr.open('PUT', link.url)

        if (link.headers) {
          for (var h in link.headers) xhr.setRequestHeader(h, link.headers[h])
        }

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            return resolve({ url: link.location || link.url.split('?')[0] })
          }
          reject({ error: { message: opt.error || 'upload failed' } })
        }

        return xhr.send(file)
      }

      xhr.open('POST', link.url)

      if (link.fields) {
        for (var k in link.fields) data.append(k, link.fields[k])
      }

      data.append('file', file, file.name)
      xhr.send(data)
    })
  }

  window.date = function date(d, type = 'date') {
    if (d == null || d === '') return ''

    if (typeof d === 'number') d = new Date(d)
    else if (typeof d === 'string') {
      var t = Date.parse(d)
      if (isNaN(t)) return ''
      d = new Date(t)
    }

    if (!(d instanceof Date) || isNaN(d.getTime())) return ''

    var pad = (n) => String(n).padStart(2, '0')

    var Y = d.getFullYear()
    var M = pad(d.getMonth() + 1)
    var D = pad(d.getDate())
    var h = pad(d.getHours())
    var m = pad(d.getMinutes())
    var s = pad(d.getSeconds())

    if (type === 'date') return `${Y}-${M}-${D}`
    if (type === 'datetime-local') return `${Y}-${M}-${D}T${h}:${m}:${s}`
    if (type === 'time') return `${h}:${m}:${s}`
    if (type === 'month') return `${Y}-${M}`

    if (type === 'week') {
      var t2 = new Date(d)
      t2.setHours(12, 0, 0, 0) // stabilize across timezones
      t2.setDate(t2.getDate() + 3 - ((t2.getDay() + 6) % 7))

      var week1 = new Date(t2.getFullYear(), 0, 4)
      week1.setHours(12, 0, 0, 0)

      var week = 1 + Math.floor((t2 - week1) / 86400000 / 7)

      return `${t2.getFullYear()}-W${pad(week)}`
    }

    return `${Y}-${M}-${D}`
  }

  window.esc = function esc(str) {
    if (typeof str != 'string') return str
    return str.replace(
      /[&<>'"]/g,
      (m) =>
        ({
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;',
          '&': '&amp;'
        })[m] || m
    )
  }

  window.isImage = function isImage(name) {
    return /\.(gif|jpe?g|tiff|png|bmp|svg)$/i.test(name)
  }

  window.num = function num(n, opt) {
    if (typeof n === 'string') {
      if (n.indexOf('_') !== -1) n = n.replace(/_/g, '')
      n = parseFloat(n)
    }

    if (typeof opt === 'string') opt = { lang: opt }
    if (!opt) opt = {}

    var lang = opt.lang || 'en'

    var fmtOpt = {}
    for (var k in opt) if (k !== 'lang') fmtOpt[k] = opt[k]

    return new Intl.NumberFormat(lang, fmtOpt).format(n)
  }

  window.raw = function raw(str) {
    if (typeof str != 'string') return str
    return str.replace(
      /&lt;|&gt;|&#39;|&quot;|&amp;/g,
      (m) =>
        ({
          '&lt;': '<',
          '&gt;': '>',
          '&#39;': "'",
          '&quot;': '"',
          '&amp;': '&'
        })[m] || m
    )
  }

  window.time = function time(date, opt) {
    if (!date) return ''
    if (typeof date === 'string') date = new Date(date)
    if (!(date instanceof Date) || isNaN(date.getTime())) return ''

    if (typeof opt === 'string') opt = { lang: opt }
    if (!opt) opt = {}

    var lang = opt.lang || 'en'
    var format = opt.format

    var fmtOpt = {}
    for (var k in opt) if (k !== 'lang' && k !== 'format') fmtOpt[k] = opt[k]

    var formatter = new Intl.DateTimeFormat(lang, fmtOpt)

    if (!format) return formatter.format(date)

    var parts = Object.create(null)
    formatter.formatToParts(date).forEach(function (p) {
      parts[p.type] = p.value
    })

    return format.replace(/%([A-Za-z]+)/g, function (m, key) {
      var lower = key.toLowerCase()
      var val = parts[lower]
      if (!val) return m
      if (key[0] !== lower[0]) val = val[0].toUpperCase() + val.slice(1)
      return val
    })
  }

  window.truncate = function truncate(str = '', size = 32) {
    return str.length > size ? str.substring(0, size).trim() + ' ...' : str
  }
})()

;

;
;(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var button = document.querySelector('.admin-logout')
    if (!button) return

    button.addEventListener('click', function (event) {
      event.preventDefault()
      button.setAttribute('aria-disabled', 'true')
      window
        .fetch('/sanity/logout', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: '{}',
          redirect: 'manual'
        })
        .finally(function () {
          window.location = '/'
        })
    })
  })
})()

;
;(function () {
  function gallery(el) {
    var index = 0
    var slides = [...el.querySelectorAll('.gallery-slide')]
    var dotter = el.querySelector('.gallery-dots')
    var dots = slides.map((_, i) => {
      var dot = document.createElement('span')
      dot.className = 'gallery-dot'
      dot.onclick = () => show(i)
      dotter.appendChild(dot)
      return dot
    })

    function show(n) {
      index = (n + slides.length) % slides.length
      slides.forEach(
        (s, i) => (s.style.display = i === index ? 'grid' : 'none')
      )
      dots.forEach((d, i) => d.classList.toggle('active', i === index))
    }

    el.querySelector('.gallery-prev')?.addEventListener('click', () =>
      show(index - 1)
    )
    el.querySelector('.gallery-next')?.addEventListener('click', () =>
      show(index + 1)
    )
    show(0)
  }

  document.addEventListener('DOMContentLoaded', () =>
    document.querySelectorAll('.gallery').forEach(gallery)
  )
})()

;
;(function () {
  async function locationLookup(endpoint, ip) {
    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ params: { ip } })
      })
      return response.json()
    } catch {
      return { ok: false }
    }
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    var R = 6371
    var φ1 = (lat1 * Math.PI) / 180
    var φ2 = (lat2 * Math.PI) / 180
    var Δφ = ((lat2 - lat1) * Math.PI) / 180
    var Δλ = ((lon2 - lon1) * Math.PI) / 180
    var a =
      Math.sin(Δφ / 2) ** 2 +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  }

  function renderLocation(loc) {
    var target = loc.locationLink?.target
    return html`
      <li>
        <div class="googlemap-list-name">
          <img
            src="/img/ui/googlemap-location.svg"
            loading="lazy"
            alt=""
          />
          <span class="googlemap-label">${esc(loc.label)}</span>
        </div>
        <div class="googlemap-list-address">
          ${esc(loc.address)}, ${esc(loc.postalCode)}, ${esc(loc.postalArea)}
        </div>
        ${(function () {
          if (target) {
            return html`<div class="googlemap-list-details">
              <a href="${esc(target)}">${esc(loc.label || target)}</a>
            </div>`
          }
          return ''
        })()}
      </li>
    `
  }

  function renderLocationList(key, locations) {
    var list = document.querySelector('#gmloc-' + key)
    if (list) {
      var sorted = locations.slice().sort(function (a, b) {
        return a.distance - b.distance
      })
      list.innerHTML = html`<ul class="googlemap-list">
        ${sorted.map(renderLocation).join('')}
      </ul>`
    }
  }

  window.initMaps = async function () {
    var maps = document.querySelectorAll('.googlemap')
    var endpoint = maps[0]?.dataset.requestIp || ''
    var result = await locationLookup(endpoint, window.userip)
    if (!result.ok) return

    var { latitude, longitude } = result.data
    var userPos = { lat: latitude, lng: longitude }

    var [{ Map }, { AdvancedMarkerElement }] = await Promise.all([
      google.maps.importLibrary('maps'),
      google.maps.importLibrary('marker')
    ])

    maps.forEach(function (el) {
      var key = el.dataset.key || ''
      var locations = JSON.parse(el.dataset.locations || '[]')
      var zoom = parseInt(el.dataset.zoom || 4)
      var position = JSON.parse(el.dataset.position || '{}')
      var center =
        position.latitude != null && position.longitude != null
          ? { lat: +position.latitude, lng: +position.longitude }
          : userPos

      var map = new Map(document.getElementById(`gmid-${key}`), {
        zoom,
        center,
        mapId: 'maps'
      })

      locations.forEach(function (loc) {
        var pos = { lat: +loc.latitude, lng: +loc.longitude }
        loc.distance = getDistance(userPos.lat, userPos.lng, pos.lat, pos.lng)

        var marker = new AdvancedMarkerElement({
          map,
          position: pos,
          title: loc.postalArea,
          gmpClickable: true
        })
        var target = loc.locationLink?.target
        if (target)
          marker.addListener('gmp-click', function () {
            window.location = target
          })
      })

      renderLocationList(key, locations)
    })
  }
})()

;
;(function () {
  function start() {
    var privacy = document.querySelector('.privacy')
    if (!privacy) return

    var notice = privacy.querySelector('.privacy-notice')
    var blockers = document.querySelectorAll('.privacy-blocked')
    var version = privacy.dataset.privacyVersion
    var value = window.cookie('privacy')

    if (blockers.length && value !== 'decline:' + version) {
      notice.hidden = false
    }

    for (var opener of document.querySelectorAll(
      '.privacy-button, .privacy-blocked'
    )) {
      opener.addEventListener('click', function () {
        notice.hidden = false
      })
    }

    for (var button of privacy.querySelectorAll('[data-privacy-choice]')) {
      button.addEventListener('click', function (event) {
        var choice = event.target.dataset.privacyChoice
        window.cookie('privacy', choice + ':' + version, {
          path: '/',
          sameSite: 'Lax'
        })
        window.location.reload()
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
